let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("la2ji")).then(() => parcelRequire('6o22p'));